import { DEFAULT_MAX_AGE_MS, STORAGE_KEY } from './constants';

import { logError } from 'middleware/logger';

/**
 * Initiates a click-to-display tracking action by saving the experience key and timestamp to localStorage.
 * Automatically cleans expired entries.
 * Updates existing entry with matching key or adds new entry.
 */
export function initiateClickToDisplayAction(key) {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return;
  }

  try {
    const entry = {
      key,
      timestamp: new Date().getTime()
    };

    const stored = localStorage.getItem(STORAGE_KEY);
    const queue = stored ? JSON.parse(stored) : { entries: [], maxAge: DEFAULT_MAX_AGE_MS };

    const existingIndex = queue.entries.findIndex(e => e.key === key);
    if (existingIndex !== -1 && queue.entries[existingIndex]) {
      queue.entries[existingIndex].timestamp = entry.timestamp;
    } else {
      queue.entries.push(entry);
    }

    const now = new Date().getTime();
    queue.entries = queue.entries.filter(e => now - e.timestamp < queue.maxAge);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
  } catch (error) {
    logError('Failed to initiate click-to-display action', error);
  }
}
